import { X } from 'lucide-react';

export default function Modal({ title, onClose, children, footer, testid = 'modal', wide = false }) {
  return (
    <div className="fixed inset-0 bg-black/50 z-[90] flex items-center justify-center p-4" data-testid={testid}>
      <div className={`bg-white rounded-lg w-full ${wide ? 'max-w-4xl' : 'max-w-2xl'} max-h-[90vh] flex flex-col text-charcoal text-left`}>
        <div className="flex justify-between items-center px-6 py-4 border-b">
          <h3 className="font-serif text-xl text-royal font-bold">{title}</h3>
          <button onClick={onClose} data-testid={`${testid}-close`}><X className="w-5 h-5" /></button>
        </div>
        <div className="p-6 overflow-y-auto flex-1">{children}</div>
        {footer && <div className="px-6 py-4 border-t flex justify-end gap-3">{footer}</div>}
      </div>
    </div>
  );
}
